export type CheckoutMode = 'pending_provider_buy_urls' | 'external_buy_urls' | 'shopify_password_locked';
export type CommerceProduct = { id: string; handle: string; name: string; price: string; type: string; description: string; buyUrl: string; sku: string; image: string; productionStatus: string };

export const checkoutMode: CheckoutMode = 'shopify_password_locked';
export const checkoutStatusNote = 'Shopify products exist, but Shopify password protection is still enabled. Store address/password removal and payment checkout verification are required before customers can buy.';

export const commerceProducts: CommerceProduct[] = [
  {
    "id": "watchers-tee-black",
    "handle": "unisex-softstyle-t-shirt",
    "name": "Watchers Tee",
    "price": "34.00",
    "type": "T-Shirt",
    "description": "Small CUSTOS front mark, full back oath, black/white Shopify variants, priced at $34.00.",
    "buyUrl": "https://custos-gear.myshopify.com/products/unisex-softstyle-t-shirt",
    "sku": "CUSTOS-TEE-001",
    "image": "/assets/product-created/watchers-tee-mockup.png",
    "productionStatus": "ACTIVE in Shopify/Printify. Tee variants corrected to $34.00. Shopify storefront password still blocks public checkout."
  },
  {
    "id": "hold-line-hoodie-black",
    "handle": "unisex-heavy-blend™-hooded-sweatshirt",
    "name": "Hold the Line Hoodie",
    "price": "72.00",
    "type": "Hoodie",
    "description": "Black hoodie with front CUSTOS chest mark, back watchtower crest, and sleeve QUIS? detail.",
    "buyUrl": "https://custos-gear.myshopify.com/products/unisex-heavy-blend%E2%84%A2-hooded-sweatshirt",
    "sku": "CUSTOS-HOOD-001",
    "image": "/assets/product-created/hoodie-mockup.png",
    "productionStatus": "ACTIVE in Shopify/Printify. Eight black variants saved at $72.00. Shopify storefront password still blocks public checkout."
  },
  {
    "id": "custos-hat-black",
    "handle": "classic-dad-hat",
    "name": "CUSTOS Hat",
    "price": "32.00",
    "type": "Hat",
    "description": "Classic Dad Hat with CUSTOS front wordmark; nine one-size color variants saved at $32.00.",
    "buyUrl": "https://custos-gear.myshopify.com/products/classic-dad-hat",
    "sku": "CUSTOS-HAT-001",
    "image": "/assets/product-created/custos-hat-mockup.png",
    "productionStatus": "ACTIVE in Shopify/Printify. Nine one-size color variants saved at $32.00. Shopify storefront password still blocks public checkout."
  },
  {
    "id": "oversight-desk-mat",
    "handle": "desk-mat",
    "name": "Oversight Desk Mat",
    "price": "42.00",
    "type": "Desk Mat",
    "description": "12 × 18 inch desk mat / mousepad with full-bleed CUSTOS Oversight Layer artwork, priced at $42.00.",
    "buyUrl": "https://custos-gear.myshopify.com/products/desk-mat",
    "sku": "CUSTOS-MAT-001",
    "image": "/assets/product-created/oversight-deskmat-mockup.png",
    "productionStatus": "ACTIVE in Shopify/Printify. One 12 × 18 inch variant saved at $42.00. Shopify storefront password still blocks public checkout."
  },
  {
    "id": "watchtower-sticker-pack",
    "handle": "watchtower-sticker-pack",
    "name": "Watchtower Sticker Pack",
    "price": "14.00",
    "type": "Sticker Pack",
    "description": "Composite sticker-sheet source exists locally; Printify login requires password before upload can continue.",
    "buyUrl": "",
    "sku": "CUSTOS-STICKER-001",
    "image": "/assets/product-created/watchtower-sticker-pack-mockup.png",
    "productionStatus": "LOCAL READY, PROVIDER BLOCKED. Individual sticker PNGs and sticker-pack-sheet.png exist; Printify requires human password login before creation can continue."
  },
  {
    "id": "patch-badge",
    "handle": "patch-badge",
    "name": "Patch / Badge",
    "price": "16.00",
    "type": "Patch",
    "description": "Patch art remains provider-selection pending; no Printify/Shopify product created yet.",
    "buyUrl": "",
    "sku": "CUSTOS-PATCH-001",
    "image": "/assets/product-created/patch-badge-mockup.png",
    "productionStatus": "LOCAL READY, PROVIDER BLOCKED. Patch vendor/blank and sample proof still required."
  }
];
